<template>
  <v-form ref="form" v-model="valid">
    <v-container class="limited" grid-list-xl>
      <v-layout row wrap fill-height>
        <v-flex xs12 md4>
          <v-card :color="highContrast ? 'dark' : 'primary'" class="pa-4">
            <h4 class="subheading grey--text mb-3">Beneficiário</h4>
            <p class="body-2 font-weight-regular white--text">
              <b>Número do cartão</b>
              <br />
              {{ dadosBeneficiario.numeroCartao }}
            </p>
            <p class="body-2 font-weight-regular white--text">
              <b>Data de inicio de vigência</b>
              <br />
              {{ dadosBeneficiario.dataInicioVigencia | formatDate }}
            </p>
            <p class="body-2 font-weight-regular white--text">
              <b>Situação atual do beneficiário</b>
              <br />
              {{ dadosBeneficiario.ativo ? "Ativo" : "Inativo" }}
            </p>
            <p class="body-2 font-weight-regular white--text">
              <b>Número do contrato</b>
              <br />
              {{ dadosBeneficiario.contratoId }}
            </p>
            <v-layout row wrap justify-end>
              <v-btn
                type="button"
                outline
                color="white"
                @click="setTrocarBeneficiario()"
                >TROCAR BENEFICIÁRIO</v-btn
              >
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md8>
          <v-card class="pa-4 elevation-5" column height="100%">
            <v-flex xs12>
              <v-layout column>
                <v-layout row wrap align-center justify-space-between="">
                  <h4 class="subheading font-weight-black primary--text pl-2">
                    Dados Pessoais
                  </h4>
                  <v-btn
                    type="button"
                    outline
                    color="grey"
                    @click="cancelar()"
                    v-if="editMode && dadosBeneficiario.ativo"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    type="button"
                    :color="highContrast ? 'dark' : 'secondary'"
                    @click="criarRascunho()"
                    v-if="!editMode && dadosBeneficiario.ativo"
                    >EDITAR DADOS</v-btn
                  >
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nome"
                      label="Nome Completo"
                      type="text"
                      v-model="pessoal.nome"
                      required
                      :disabled="!editMode"
                      data-cy="nomeField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg4 class="py-0">
                    <v-text-field
                      name="dataNascimento"
                      label="Data de Nascimento"
                      type="text"
                      v-model="pessoal.dataNascimento"
                      :rules="dataNascimentoRules"
                      required
                      v-mask="'##/##/####'"
                      :masked="true"
                      :disabled="!editMode"
                      data-cy="dataNascimentoField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg4 class="py-0">
                    <v-text-field
                      name="cpf"
                      label="CPF"
                      type="text"
                      v-model="pessoal.cpf"
                      required
                      :disabled="!editMode"
                      v-mask="'###.###.###-##'"
                      :masked="false"
                      data-cy="cpfField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="pessoal.rg">
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="RG"
                      label="RG"
                      type="text"
                      v-model="pessoal.rg.numero"
                      :disabled="true"
                      required
                      data-cy="rgField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="dataExpedicao"
                      label="Data Expedição"
                      type="text"
                      v-model="pessoal.rg.dataExpedicao"
                      :disabled="!editMode"
                      :rules="dataExpedicaoRules"
                      v-mask="'##/##/####'"
                      :masked="true"
                      required
                      data-cy="dataExpedicaoField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg2 class="py-0">
                    <v-select
                      required
                      return-object
                      item-text="descricao"
                      label="UF Emissor"
                      v-model="pessoal.rg.ufEmissor"
                      :disabled="!editMode"
                      :items="dmListaUf"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nomeMae"
                      label="Nome da Mãe"
                      type="text"
                      v-model="pessoal.nomeMae"
                      :disabled="!editMode"
                      required
                      data-cy="nomeMaeField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nomePai"
                      label="Nome do Pai"
                      type="text"
                      v-model="pessoal.nomePai"
                      :disabled="!editMode"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--textb-3">
                  Endereço
                </h4>
                <v-switch
                  v-if="listEnderecos && listEnderecos.length > 0 && !isTitular"
                  label="Reside com o titular do plano"
                  :disabled="!editMode"
                  v-model="moraComTitular"
                  @change="onChangeEnderecoTitular"
                  color="orange darken-4"
                ></v-switch>
                <template v-for="(endereco, index) in listEnderecos">
                  <v-layout column :key="index" class="ma-1 mb-5">
                    <v-layout row wrap>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-select
                          required
                          return-object
                          item-text="descricao"
                          label="Tipo"
                          v-model="endereco.tipoEndereco"
                          :disabled="!editMode || !isTitular"
                          :items="dmTiposEnderecos"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          required
                          data-cy="cepField"
                          label="CEP"
                          name="cep"
                          v-mask="'#####-###'"
                          v-model="endereco.cep"
                          @blur="buscaCep(index, endereco.cep)"
                          :disabled="!editMode"
                          :masked="false"
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          required
                          data-cy="streetField"
                          label="Rua"
                          maxlength="100"
                          name="street"
                          type="text"
                          v-model="endereco.logradouro"
                          :disabled="
                            !editMode ||
                              enderecosDesabilitaEdicao[index].logradouro
                          "
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg2 class="py-0">
                        <v-text-field
                          required
                          data-cy="numberField"
                          label="Número"
                          maxlength="5"
                          name="number"
                          type="text"
                          v-model="endereco.numero"
                          :disabled="!editMode"
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          required
                          data-cy="districtField"
                          label="Bairro"
                          maxlength="40"
                          name="district"
                          type="text"
                          v-model="endereco.bairro"
                          :disabled="
                            !editMode || enderecosDesabilitaEdicao[index].bairro
                          "
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg4 class="py-0">
                        <v-text-field
                          required
                          data-cy="cityField"
                          label="Cidade"
                          maxlength="72"
                          name="city"
                          type="text"
                          v-model="endereco.cidade"
                          :disabled="
                            !editMode || enderecosDesabilitaEdicao[index].cidade
                          "
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg1 class="py-0">
                        <v-text-field
                          required
                          data-cy="stateField"
                          label="Estado"
                          name="state"
                          type="text"
                          v-model="endereco.uf"
                          :disabled="
                            !editMode || enderecosDesabilitaEdicao[index].uf
                          "
                          :rules="[requiredRule]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          required
                          data-cy="complementField"
                          label="Complemento"
                          maxlength="30"
                          name="complement"
                          type="text"
                          v-model="endereco.complemento"
                          :disabled="!editMode"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          required
                          data-cy="caixaPostalField"
                          label="Caixa Postal"
                          name="caixaPostal"
                          type="text"
                          v-model="endereco.caixaPostal"
                          :disabled="!editMode"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4 lg3 class="py-0">
                        <v-text-field
                          required
                          data-cy="pontoReferenciaField"
                          label="Ponto de referência"
                          name="pontoReferencia"
                          type="text"
                          v-model="endereco.pontoReferencia"
                          :disabled="!editMode"
                        ></v-text-field>
                      </v-flex>
                      <v-flex
                        xs12
                        md4
                        lg6
                        v-if="!parametroEnderecoFinalidadesDefault"
                      >
                        <h5 class="subheading">
                          Quando necessário, é neste endereço que gostaria de
                          receber:
                        </h5>
                        <v-layout row wrap>
                          <div
                            v-for="(finalidade,
                            indexFinalidade) in endereco.finalidades"
                            :key="indexFinalidade"
                            class="mr-3"
                          >
                            <v-checkbox
                              :key="indexFinalidade"
                              v-model="
                                endereco.finalidades[indexFinalidade]
                                  .selecionado
                              "
                              :label="finalidade.descricao"
                              :disabled="!editMode"
                              color="primary"
                              hide-details
                            />
                          </div>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-end>
                      <v-btn
                        small
                        type="button"
                        :disabled="!editMode"
                        @click="removeEndereco(index)"
                        :color="highContrast ? 'dark' : 'gray'"
                        >Remover</v-btn
                      >
                    </v-layout>
                    <v-divider
                      v-if="index + 1 < enderecos.length"
                      :key="index"
                    ></v-divider>
                  </v-layout>
                </template>
                <v-layout row>
                  <v-btn
                    small
                    type="button"
                    v-if="isTitular"
                    :disabled="!editMode"
                    @click="addEndereco()"
                    :color="highContrast ? 'dark' : 'secondary'"
                    >Adicionar</v-btn
                  >
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-if="
            this.editMode &&
              this.rascunho &&
              (isTitular &&
                this.dadosBeneficiario.faturaContra == 'T' &&
                permiteAlterarTipoRecebimentoBoleto)
          "
        >
          <v-card column class="pa-4 elevation-5">
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text mt-2">
                  Recebimento de boletos
                </h4>
              </v-layout>
              <v-layout row>
                <v-flex xs12 md6 lg4 class="py-3">
                  <uni-select
                    :options="dmRecebimentoBoletos"
                    placeholder="Gostaria de receber os boletos por"
                    @change="setTipoRecebimentoBoleto"
                    v-model="tipoRecebimentoBoleto"
                  ></uni-select>
                </v-flex>
                <v-flex xs12 md6 lg4 class="py-0" v-if="isFaturaContraTitular">
                  <v-text-field
                    name="diaVencimento"
                    label="Dia do Vencimento"
                    v-model="diaVencimento"
                    type="number"
                    :rules="dateValueRule"
                    :disabled="!permiteAlterarVencimentoParam"
                  ></v-text-field>
                  <label>
                    As alterações realizadas no dia do vencimento serão
                    aplicadas após a próxima geração de fatura.
                  </label>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column v-if="!this.moraComTitular">
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Contato
                </h4>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="phone"
                      label="Telefone"
                      type="text"
                      :disabled="!editMode"
                      v-model="contatoTelefone.contato"
                      v-mask="'(##)#####-####'"
                      required
                      data-cy="phoneField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="cellPhone"
                      label="Celular"
                      type="text"
                      :disabled="!editMode"
                      v-mask="'(##)#####-####'"
                      v-model="contatoCelular.contato"
                      required
                      data-cy="cellPhoneField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg3 class="py-0">
                    <v-text-field
                      name="email"
                      label="E-mail"
                      type="text"
                      :disabled="!editMode"
                      v-model="contatoEmail.contato"
                      required
                      data-cy="emailField"
                    ></v-text-field>
                    <label
                      v-if="
                        mostraTiposRecebimentoBoleto &&
                          (isTitular &&
                            this.dadosBeneficiario.faturaContra == 'T')
                      "
                      id="lblInfoBoleto"
                    >
                      Esse e-mail será usado para receber os boletos.</label
                    >
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="this.editMode && this.rascunho">
          <v-card column class="pa-4 elevation-5">
            <v-flex xs12>
              <v-layout column>
                <mensagem-anexo
                  :parametro-id="parametroMensagemAnexo"
                ></mensagem-anexo>
                <h4 class="subheading font-weight-black primary--text mt-2">
                  Anexos
                </h4>
                <v-layout row wrap>
                  <v-flex xs12 md4 class="px-2">
                    <v-select
                      :clearable="true"
                      :items="dmTiposAnexos"
                      v-model="anexo.tipo"
                      item-text="descricao"
                      item-value="id"
                      label="Tipo Anexo"
                    ></v-select>
                    <label
                      >Extensões permitidas:
                      .zip,.pdf,.csv,.xls,.odt,.doc,.docx,.txt,.png,.jpg,.jpeg.
                    </label>
                  </v-flex>
                  <v-flex xs12 md4 class="px-2 pt-4">
                    <v-layout row>
                      <v-text-field
                        name="filename"
                        label="Arquivo"
                        type="text"
                        v-model="anexo.arquivo"
                        disabled
                      ></v-text-field>
                      <v-btn
                        flat
                        icon
                        color="grey darken-2"
                        class="body-2 text-none"
                        @click="$refs.file.click()"
                      >
                        <v-icon>attach_file</v-icon>
                      </v-btn>
                      <input
                        type="file"
                        style="display: none"
                        @change="uploadAnexo"
                        ref="file"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md4 class="px-2">
                    <v-btn
                      light
                      @click="adicionarAnexo()"
                      :disabled="!anexo.tipo || !anexo.arquivo"
                      :color="highContrast ? 'white' : 'primary'"
                      >Adicionar</v-btn
                    >
                  </v-flex>
                </v-layout>
                <v-list two-line v-if="movimentoAnexos">
                  <template v-for="(item, index) in movimentoAnexos">
                    <v-list-tile :key="item.id" ripple>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.anexo.filename }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">
                          {{ item.tipoAnexo.descricao }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon @click="removerAnexo(index)">delete</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < movimentoAnexos.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-layout row justify-end align-center wrap>
            <small class="caption mx-2"
              >Os dados alterados serão analisados previamente pela
              Unimed</small
            >
            <v-btn
              :color="highContrast ? 'dark' : 'secondary'"
              @click="salvar()"
              v-if="this.editMode && this.rascunho"
              >ATUALIZAR DADOS</v-btn
            >
          </v-layout>
          <loading-dialog :show="loading" message="Aguarde..."></loading-dialog>
        </v-flex>
      </v-layout>
    </v-container>
    <modal-movimento-aberto
      @close="modal.MOVIMENTO_ABERTO.visible = false"
      :show="modal.MOVIMENTO_ABERTO.visible"
      :message="modal.MOVIMENTO_ABERTO.content"
    ></modal-movimento-aberto>
    <modal-movimento-duplicado
      @close="modal.MOVIMENTO_DUPLICADO.visible = false"
      @overwrite="sobrescreverMovimento"
      :show="modal.MOVIMENTO_DUPLICADO.visible"
      :message="modal.MOVIMENTO_DUPLICADO.content"
    ></modal-movimento-duplicado>
    <modal-movimento
      @close="modal.MOVIMENTO_BLOQUEADO.visible = false"
      :titulo="modal.MOVIMENTO_BLOQUEADO.titulo"
      :show="modal.MOVIMENTO_BLOQUEADO.visible"
      :message="modal.MOVIMENTO_BLOQUEADO.content"
    ></modal-movimento>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { createNamespacedHelpers } from "vuex";

import api from "@/api/movimentos";
import moment from "moment";

import {
  PARAMETROS,
  WEB_SERVICE,
  DOCUMENTOS,
  LISTA_UF,
  FINALIDADES
} from "@/constants";

import LoadingDialog from "@/components/LoadingDialog";
import MensagemAnexo from "@/components/MensagemAnexo";
import ModalMovimento from "@/components/ModalMovimento";
import ModalMovimentoAberto from "@/components/ModalMovimentoAberto";
import ModalMovimentoDuplicado from "@/components/ModalMovimentoDuplicado";
import { buscaParametroValorTipoBooleanAtivo } from "@/services/beneficiario";

import { getCep, getParametro } from "@/services/beneficiario";
import {
  cancelarMovimento,
  cancelarMovimentos,
  createMovimentoAlteracao,
  enviarMovimentoParaAuditoriaQueue,
  getDadosPessoais,
  getEnderecoBeneficiario,
  getEnderecosFinalidade,
  listarMovimentoAnexos,
  getMovimentosDuplicados,
  getPessoaEnderecos,
  getPessoaContatos,
  getTiposEnderecos,
  listarTiposAnexo,
  removerAnexo,
  updateMovimentoAlteracao,
  cadastrarAnexo
} from "@/services/movimentos";

const ENDERECO_RESIDENCIA_ID = "00000000-0000-0000-0000-000000000001";
const ENDERECO_TRABALHO_ID = "00000000-0000-0000-0000-000000000002";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");
const dateFormat = "YYYY-MM-DD";
const currentDate = moment().format(dateFormat);

export default {
  name: "UpdateRegistration",
  directives: { mask },
  components: {
    LoadingDialog,
    MensagemAnexo,
    ModalMovimentoAberto,
    ModalMovimentoDuplicado,
    ModalMovimento
  },
  props: {
    createDraft: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario", "familiaPessoa"]),
    ...portalStore.mapState(["highContrast", "usuario"]),
    isTitular() {
      return this.dadosBeneficiario.titular;
    },
    pessoaId() {
      return this.dadosBeneficiario.pessoaId;
    }
  },
  data() {
    return {
      loading: false,
      valid: false,
      editMode: false,
      dadosPessoais: null,
      diaVencimento: "",
      pessoaEnderecos: null,
      pessoaContatos: null,
      dmTiposEnderecos: null,
      dmListaUf: LISTA_UF,
      dmTiposAnexos: null,
      dmRecebimentoBoletos: [],
      tiposRecebimentoBoleto: [],
      mostraTiposRecebimentoBoleto: null,
      tipoRecebimentoBoletoId: null,
      tipoRecebimentoBoleto: null,
      parametroMensagemAnexo: 1,
      parametroEnderecoFinalidadesDefault: null,
      permiteAlterarVencimentoParam: false,
      permiteAlterarTipoRecebimentoBoleto: false,
      finalidades: [],
      requiredRule: campo => !!campo || "Campo obrigatório",
      dateValueRule: [
        dia =>
          dia >= 1 || "O valor do dia de vencimento deve estar entre 1 e 31",
        dia =>
          dia <= 31 || "O valor do dia de vencimento deve estar entre 1 e 31"
      ],
      modal: {
        MOVIMENTO_ABERTO: { visible: false, content: null },
        MOVIMENTO_DUPLICADO: {
          visible: false,
          content: null,
          movimentoId: null
        },
        MOVIMENTO_BLOQUEADO: {
          visible: false,
          content: null,
          titulo: "Atualização Cadastral"
        }
      },
      dataExpedicaoRules: [
        dataExpedicao => !!dataExpedicao || "A Data de expedição é obrigatória",
        dataExpedicao =>
          dataExpedicao?.length === 10 || "A Data de expedição deve ser válida"
      ],
      dataNascimentoRules: [
        dataNascimento =>
          !!dataNascimento || "A Data de nascimento é obrigatória",
        dataNascimento =>
          dataNascimento?.length === 10 ||
          "A Data de nascimento deve ser válida"
      ],
      pessoal: {
        nome: "",
        dataNascimento: "",
        cpf: "",
        nomeMae: "",
        nomePai: "",
        rg: null
      },
      enderecos: [],
      listEnderecos: [],
      novoEndereco: {
        bairro: "",
        caixaPostal: null,
        cep: "",
        cidade: "",
        complemento: null,
        id: null,
        logradouro: "",
        numero: "",
        pontoReferencia: null,
        tipoEndereco: {
          id: ENDERECO_RESIDENCIA_ID,
          descricao: "Minha residencia"
        },
        uf: ""
      },
      contatoCelular: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000001",
          descricao: "Celular"
        },
        contato: null
      },
      contatoTelefone: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000002",
          descricao: "Telefone Fixo"
        },
        contato: null
      },
      contatoEmail: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000003",
          descricao: "E-mail"
        },
        contato: null
      },
      anexo: {
        tipo: null,
        arquivo: null
      },
      tipoRecebimentoBoletos: [],
      movimentoAnexos: null,
      rascunho: null,
      moraComTitular: false,
      blockUpdateBeneficiario: {
        isBlock: false,
        message: ""
      },
      bloquearEdicao: false,
      enderecoDesabilitaEdicao: {
        cep: false,
        logradouro: false,
        numero: false,
        bairro: false,
        cidade: false,
        uf: false
      },
      enderecosDesabilitaEdicao: []
    };
  },
  watch: {
    pessoaId: {
      handler() {
        this.cancelar();
        this.loadPage();
      }
    },
    dadosPessoais: {
      handler(dadosPessoais) {
        if (dadosPessoais) {
          const dataNascimento = dadosPessoais[0].dataNascimento.split("-");
          this.pessoal.nome = dadosPessoais[0].nome;
          this.pessoal.dataNascimento =
            dataNascimento[2] +
            "/" +
            dataNascimento[1] +
            "/" +
            dataNascimento[0];
          this.pessoal.cpf = dadosPessoais[0].cpf;
          this.pessoal.nomeMae = dadosPessoais[0].nomeMae;
          this.pessoal.nomePai = dadosPessoais[0].nomePai;
        }
      }
    },
    pessoaContatos: {
      handler(contatos) {
        if (contatos) {
          contatos.forEach(contato => {
            const chaves = contato.id.split(";");
            const tipo = chaves[2];

            if (tipo === "T") {
              this.contatoTelefone.contato = contato.contato;
            } else if (tipo === "C") {
              this.contatoCelular.contato = contato.contato;
            } else if (tipo === "E") {
              this.contatoEmail.contato = contato.contato;
            }
          });
        }
      }
    }
  },
  async created() {
    this.permiteAlterarTipoRecebimentoBoleto = await buscaParametroValorTipoBooleanAtivo(
      PARAMETROS.HABILITAR_ALTERACAO_TIPO_RECEBIMENTO_BOLETO
    );
    this.tiposAnexos();
    this.tiposEnderecos();
    this.enderecosFinalidade();
    this.tiposRecebimentoBoletos();

    await this.loadPage();

    if (this.createDraft) {
      this.criarRascunho();
    }
  },
  methods: {
    ...beneficiarioStore.mapMutations(["setTrocarBeneficiario"]),
    ...portalStore.mapMutations(["setErrorToast", "setToast"]),
    verificaBeneficiarioDependente() {
      var titular = this.familiaPessoa.find(f => f.titular == true && f.ativo);
      const contratoDependente = this.familiaPessoa.find(
        f => f.titular == false && f.ativo
      )?.contratoId;
      const beneficiario = this.dadosBeneficiario.id.split("-")[1];

      if (!titular && this.blockUpdateBeneficiario.isBlock) {
        this.bloquearEdicao = true;
      } else if (
        beneficiario != "00" &&
        titular?.contratoId != contratoDependente
      ) {
        this.bloquearEdicao = true;
      } else {
        this.bloquearEdicao = false;
      }
    },
    async loadPage() {
      this.loading = true;

      await Promise.all([
        this.getDadosPessoais(),
        this.getNivelEnderecoBeneficiario(),
        this.getBeneficiarioEnderecos(),
        this.getPessoaContatos(),
        this.getParametroBlockUpdateBeneficiario(),
        this.getParametroBlockUpdateBeneficiarioMessage(),
        this.getParametroPermiteAlterarDiaVencimento(),
        this.getParametroFinalidadesDefault()
      ]).finally(() => {
        this.loading = false;
      });
    },
    removeEndereco(index) {
      this.listEnderecos.splice(index, 1);
      this.enderecosDesabilitaEdicao.splice(index, 1);
    },
    getNivelEnderecoBeneficiario() {
      this.$api
        .get(api.nivelEnderecoBeneficiario)
        .then(response => response.data)
        .catch(error => {
          var errorMessage = error.response.data.message.split("|");

          if (WEB_SERVICE.includes(errorMessage[0])) {
            this.setErrorToast(error?.response?.data?.message);
          } else {
            this.setToast("Erro ao carregar o parâmetro de nível do endereço");
          }
        });
    },
    cancelar() {
      this.editMode = false;

      this.enderecosDesabilitaEdicao = [];
      this.pessoal.rg = null;
      const movimentoId = this.rascunho?.id;
      if (movimentoId) {
        cancelarMovimento(movimentoId).finally(() => {
          this.rascunho = null;
          this.loadPage();
        });
      }
    },
    addEndereco() {
      const hasTipoEnderecoResidencia = this.listEnderecos.find(
        endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
      );

      const tipoEnderecoSugerido = hasTipoEnderecoResidencia
        ? ENDERECO_TRABALHO_ID
        : ENDERECO_RESIDENCIA_ID;

      const tipoEndereco = this.dmTiposEnderecos.find(
        tipo => tipo.id === tipoEnderecoSugerido
      );

      const novoEndereco = Object.assign({}, this.novoEndereco);
      novoEndereco.tipoEndereco = tipoEndereco;
      novoEndereco.finalidades = this.finalidades.map(finalidade => {
        finalidade.idd = Math.random();
        finalidade.selecionado = null;
        return finalidade;
      });
      this.listEnderecos.push(novoEndereco);
      this.enderecosDesabilitaEdicao.push(this.enderecoDesabilitaEdicao);
    },
    async getParametroPermiteAlterarDiaVencimento() {
      const permiteAlterarVencimentoParamId = 19;
      const response = await getParametro(permiteAlterarVencimentoParamId);
      this.permiteAlterarVencimentoParam = response === "true";
    },
    async getParametroBlockUpdateBeneficiarioMessage() {
      const parametroId = 11;

      this.blockUpdateBeneficiario.message = await getParametro(parametroId);
    },
    async getParametroBlockUpdateBeneficiario() {
      const parametroId = 10;

      this.blockUpdateBeneficiario.isBlock =
        (await getParametro(parametroId)) === "true";

      this.verificaBeneficiarioDependente();
    },
    async isFaturaContraTitular() {
      return this.dadosBeneficiario?.faturaContra === "T";
    },
    async criarRascunho() {
      this.loading = true;
      const isFaturaCorreta =
        this.dadosBeneficiario?.faturaContra === "E" ||
        this.dadosBeneficiario?.faturaContra === "T";

      if (
        this.blockUpdateBeneficiario?.isBlock &&
        this.bloquearEdicao &&
        isFaturaCorreta
      ) {
        this.modal.MOVIMENTO_BLOQUEADO.visible = true;
        this.modal.MOVIMENTO_BLOQUEADO.content = this.blockUpdateBeneficiario.message;
        this.loading = false;
      } else {
        await getMovimentosDuplicados({
          codigoBeneficiario: this.dadosBeneficiario.id,
          tipoMovimentoId: 2
        })
          .then(response => {
            const errorMessage = response.data?.message;

            if (errorMessage) {
              const resultado = errorMessage.split("|");

              if (WEB_SERVICE.includes(resultado[0])) {
                this.setErrorToast(errorMessage);
              } else {
                this.modal.MOVIMENTO_ABERTO.visible = true;
                this.modal.MOVIMENTO_ABERTO.content = errorMessage.replace(
                  "\n",
                  "<br>"
                );
                this.cancelar();
              }
            } else {
              if (response.length) {
                const movimento = response.filter(
                  movimento =>
                    movimento?.nomeBeneficiario &&
                    movimento?.tipoMovimento?.descricao
                )[0];
                const movimentosId = response.map(movimento => movimento.id);

                this.modal.MOVIMENTO_DUPLICADO.visible = true;
                this.modal.MOVIMENTO_DUPLICADO.content = `Foi encontrado um movimento de ${
                  movimento?.tipoMovimento?.descricao
                } criado para ${movimento?.nomeBeneficiario}!`;
                this.modal.MOVIMENTO_DUPLICADO.movimentosId = movimentosId;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (
        !this.modal.MOVIMENTO_ABERTO.visible &&
        !this.modal.MOVIMENTO_DUPLICADO.visible &&
        !this.modal.MOVIMENTO_BLOQUEADO.visible
      ) {
        this.createAlteracao();
      }
    },
    createAlteracao() {
      this.loading = true;

      const codigoGrauDependencia = this.dadosBeneficiario.id.split("-")[1];
      const tipoMovimento = this.dadosBeneficiario.titular
        ? "titular"
        : "dependente";
      const params = {
        beneficiarioCartao: this.dadosBeneficiario.id,
        codigoEmpresa: this.dadosBeneficiario.empresaId,
        codigoContrato: this.dadosBeneficiario.contratoId,
        codigoTitular: !this.dadosBeneficiario.titular
          ? this.dadosBeneficiario.titularId
          : undefined,
        codigoGrauDependencia,
        usuarioId: this.usuario.id
      };

      createMovimentoAlteracao(tipoMovimento, params)
        .then(response => {
          this.editMode = true;
          this.rascunho = response;
          this.diaVencimento = response.diaVencimento;
          this.tipoRecebimentoBoleto = this.rascunho?.tipoRecebimentoBoleto?.descricao;
          this.moraComTitular = response.moraComTitular;
          this.pessoal.nome = this.rascunho.nome;
          this.pessoal.nomeMae = this.rascunho.nomeMae;
          const dataNascimento = this.rascunho.dataNascimento.split("-");
          this.pessoal.dataNascimento =
            dataNascimento[2] +
            "/" +
            dataNascimento[1] +
            "/" +
            dataNascimento[0];

          for (let index = 1; index <= 3; index++) {
            const contato = this.rascunho.movimentoContatos.find(
              contato =>
                contato.tipoContato.id ===
                "00000000-0000-0000-0000-00000000000" + index
            );
            if (contato) {
              if (index === 1) {
                this.contatoCelular = contato;
              } else if (index === 2) {
                this.contatoTelefone = contato;
              } else if (index === 3) {
                this.contatoEmail = contato;
              }
            }
          }

          this.pessoal.rg = this.rascunho.movimentoDocumentos.find(
            documento => documento.tipoDocumento.id == DOCUMENTOS.RG
          );

          if (this.pessoal.rg && this.pessoal.rg.dataExpedicao) {
            const dataExpedicao = this.pessoal.rg.dataExpedicao.split("-");
            this.pessoal.rg.dataExpedicao =
              dataExpedicao[2] +
              "/" +
              dataExpedicao[1] +
              "/" +
              dataExpedicao[0];
          }

          this.editMode = true;
        })
        .catch(({ response }) => {
          let errorMessage = response?.data?.message;
          errorMessage = errorMessage.split(": ")[1] || errorMessage;

          const resultado = errorMessage.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(errorMessage);
          } else {
            if (response.data) {
              this.modal.MOVIMENTO_ABERTO.visible = true;
              this.modal.MOVIMENTO_ABERTO.content = response.data?.message.replace(
                "\n",
                "<br>"
              );
            }
            this.cancelar();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async onChangeEnderecoTitular(value) {
      if (value) {
        this.listEnderecos = await this.getEnderecoTitular();
      } else {
        this.novoEndereco.finalidades = this.finalidades.map(finalidade => {
          finalidade.idd = Math.random();
          finalidade.selecionado = null;
          return finalidade;
        });

        this.listEnderecos[0] = this.novoEndereco;
      }
    },
    getEnderecoTitular() {
      if (!this.dadosBeneficiario.titular) {
        return getEnderecoBeneficiario(
          null,
          this.dadosBeneficiario.pessoaTitularId
        ).then(({ data, errors }) => {
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          } else {
            return data.pessoaEnderecos.filter(
              endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
            );
          }
        });
      }
    },
    verificaEdicaoCamposEndereco(index, response) {
      if (response.uf && response.cidade && !response.logradouro) {
        this.enderecosDesabilitaEdicao[
          index
        ] = this.enderecoDesabilitaEdicao = {
          cep: true,
          logradouro: false,
          numero: false,
          bairro: false,
          cidade: true,
          uf: true
        };
      } else {
        this.enderecosDesabilitaEdicao[
          index
        ] = this.enderecoDesabilitaEdicao = {
          cep: false,
          logradouro: true,
          numero: false,
          bairro: true,
          cidade: true,
          uf: true
        };
      }
    },
    salvar() {
      this.loading = true;
      let error = "";
      if (!this.$refs.form.validate()) {
        error = "O formulário apresenta campos pendentes";
      } else if (
        this.listEnderecos.filter(
          endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
        ).length === 0
      ) {
        error =
          "Deve haver pelo menos um endereço tipo 'Minha residência' informado";
      } else if (
        this.listEnderecos.filter(
          endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
        ).length > 1
      ) {
        error = "Apenas um endereço do tipo 'Minha residência' pode informado";
      } else if (
        this.listEnderecos.filter(
          endereco =>
            endereco.tipoEndereco.id === "00000000-0000-0000-0000-000000000002"
        ).length > 1
      ) {
        error = "Apenas um endereço do tipo 'Meu trabalho' pode informado";
      } else if (
        !this.tipoRecebimentoBoleto &&
        this.isTitular &&
        this.dadosBeneficiario.faturaContra == "T"
      ) {
        error = "Você não informou a forma como prefere receber seus boletos.";
      }

      if (error) {
        this.setToast(error);
        this.loading = false;
        return;
      }

      const contatos = [];

      if (this.contatoCelular.contato) {
        contatos.push({
          movimento: {
            id: this.rascunho.id
          },
          contato: this.contatoCelular.contato,
          tipoContato: {
            id: "00000000-0000-0000-0000-000000000001"
          }
        });
      }

      if (this.contatoTelefone.contato) {
        contatos.push({
          movimento: {
            id: this.rascunho.id
          },
          contato: this.contatoTelefone.contato,
          tipoContato: {
            id: "00000000-0000-0000-0000-000000000002"
          }
        });
      }

      if (this.contatoEmail.contato) {
        contatos.push({
          movimento: {
            id: this.rascunho.id
          },
          contato: this.contatoEmail.contato,
          tipoContato: {
            id: "00000000-0000-0000-0000-000000000003"
          }
        });
      }

      const documentos = this.rascunho.movimentoDocumentos.map(documento => {
        const documentoFormatado = {
          orgaoEmissor: documento.orgaoEmissor
            ? documento.orgaoEmissor.id
            : null,
          movimento: {
            id: this.rascunho.movimento.id
          },
          dataExpedicao: this.getDataExpedicao(documento.dataExpedicao),
          numero: documento.numero,
          tipoDocumento: documento.tipoDocumento,
          ufEmissor: documento.ufEmissor
        };

        return documentoFormatado;
      });

      const enderecos = this.listEnderecos.map(endereco => {
        endereco.id = undefined;

        if (
          endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID &&
          endereco.idEndereco
        ) {
          endereco.idEndereco =
            endereco.idEndereco.slice(0, -1) + ENDERECO_RESIDENCIA_ID.slice(-1);
        }

        endereco.cep = endereco.cep.replace(/\.|-/g, "");
        endereco.movimento = {
          id: this.rascunho.movimento.id
        };

        if (this.parametroEnderecoFinalidadesDefault) {
          if (endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID) {
            endereco.finalidades.forEach(finalidade => {
              if (
                finalidade.id == FINALIDADES.FATURA ||
                finalidade.id == FINALIDADES.CORRESPONDENCIA
              ) {
                finalidade.selecionado = true;
              }
            });
          }
        }

        endereco.enderecoFinalidades = endereco.finalidades
          .filter(finalidade => finalidade.selecionado)
          .map(finalidade => {
            return {
              id: finalidade.id
            };
          });
        return endereco;
      });

      if (this.tipoRecebimentoBoleto) {
        this.setTipoRecebimentoBoleto(null, this.tipoRecebimentoBoleto);
      }

      const dataNascimento = this.pessoal.dataNascimento.split("/");
      const params = {
        ...this.rascunho,
        codigoContrato:
          this.rascunho.contrato?.contratoId ||
          this.dadosBeneficiario.contratoId,
        diaVencimento: this.diaVencimento,
        dataNascimento:
          dataNascimento[2] + "-" + dataNascimento[1] + "-" + dataNascimento[0],
        nomeBeneficiario: this.pessoal.nome,
        nomeMae: this.pessoal.nomeMae,
        nomePai: this.pessoal.nomePai,
        movimento: {
          ...this.rascunho.movimento,
          movimentoContatos: contatos,
          movimentoDocumentos: documentos,
          movimentoEnderecos: enderecos
        },
        tipoRecebimentoBoleto: this.tipoRecebimentoBoletoId
      };

      updateMovimentoAlteracao(params)
        .then(() => {
          enviarMovimentoParaAuditoriaQueue(this.rascunho.movimento.id)
            .then(() => {
              this.setToast(
                "Sua alteração foi confirmada, ela será analisada pela Unimed."
              );
            })
            .catch(({ response }) => {
              const resultado = response?.data?.message.split("|");

              if (WEB_SERVICE.includes(resultado[0])) {
                this.setErrorToast(response.data?.message);
              } else {
                this.setToast(
                  response.data ? response.data.message : response.message
                );
              }
            })
            .finally(() => {
              this.editMode = false;
              this.loading = false;
            });
        })
        .catch(({ response }) => {
          let errorMessage = response.data?.message;
          errorMessage = errorMessage.split(": ")[1] || errorMessage;

          const resultado = errorMessage.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(errorMessage);
          } else {
            if (response.data) {
              this.modal.MOVIMENTO_ABERTO.visible = true;
              this.modal.MOVIMENTO_ABERTO.content = response.data?.message.replace(
                "\n",
                "<br>"
              );
            }
            this.cancelar();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async enderecosFinalidade() {
      await getEnderecosFinalidade(true).then(response => {
        this.finalidades = response;
      });
    },
    async tiposEnderecos() {
      await getTiposEnderecos(true).then(response => {
        this.dmTiposEnderecos = response;
      });
    },
    getDataExpedicao(dataExpedicaoParam) {
      if (dataExpedicaoParam) {
        const dataExpedicao = dataExpedicaoParam.split("/");
        return (
          dataExpedicao[2] + "-" + dataExpedicao[1] + "-" + dataExpedicao[0]
        );
      }
    },
    async getDadosPessoais() {
      await getDadosPessoais(this.pessoaId).then(({ data, errors }) => {
        this.dadosPessoais = data?.dadosPessoais;

        if (errors && errors[0]?.message) {
          const errorMessage = errors[0]?.message?.split(": ")[1];

          this.setErrorToast(errorMessage);
        }
      });
    },
    async getBeneficiarioEnderecos() {
      const codigoBeneficiario = this.dadosBeneficiario.id;

      await getEnderecoBeneficiario(this.pessoaId, codigoBeneficiario).then(
        async response => {
          const errorMessage = response.data?.message;

          if (errorMessage) {
            this.setErrorToast(errorMessage);
          } else {
            if (response.data.length > 0) {
              this.listEnderecos = response.data;
            }
          }
        }
      );

      if (!this.listEnderecos.length) {
        this.listEnderecos = await this.getEnderecoTitular();
      }

      this.listEnderecos = JSON.parse(JSON.stringify(this.listEnderecos)).map(
        endereco => {
          endereco.finalidades = JSON.parse(
            JSON.stringify(this.finalidades)
          ).map(finalidade => {
            finalidade.idd = Math.random();
            finalidade.selecionado = endereco.enderecoFinalidades.find(
              enderecoFinalidade => enderecoFinalidade.id === finalidade.id
            )
              ? true
              : null;

            return finalidade;
          });

          this.enderecosDesabilitaEdicao.push(this.enderecoDesabilitaEdicao);

          return endereco;
        }
      );

      if (!this.isTitular && this.listEnderecos.length > 1) {
        this.listEnderecos = this.listEnderecos.filter(
          endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
        );
      }
    },
    async getPessoaContatos() {
      await getPessoaContatos(this.pessoaId).then(({ data, errors }) => {
        if (errors && errors.length) {
          const errorMessage = errors[0].message.split(": ")[1];

          this.setErrorToast(errorMessage);
        } else {
          this.pessoaContatos = data.pessoaContatos;
        }
      });
    },
    async getPessoaEnderecos(pessoaId) {
      await getPessoaEnderecos(pessoaId);
    },
    sobrescreverMovimento() {
      const movimentosId = this.modal.MOVIMENTO_DUPLICADO.movimentosId;

      if (movimentosId) {
        cancelarMovimentos(movimentosId).finally(() => {
          this.loading = true;
          this.modal.MOVIMENTO_DUPLICADO.visible = false;

          this.createAlteracao();
        });
      }
    },
    uploadAnexo(e) {
      this.file = e.target.files[0];
      this.anexo.arquivo = this.file.name;
    },
    adicionarAnexo() {
      let fd = new FormData();
      fd.append("arquivo", this.file);
      fd.append("movimento", this.rascunho.id);
      fd.append("tipoAnexo", this.anexo.tipo);
      cadastrarAnexo(this.anexo.tipo, this.rascunho.id, fd)
        .then(() => {
          this.$toast.success(`Arquivo adicionado com sucesso.`);
          this.listarMovimentoAnexos();
        })
        .catch(error => {
          let msgErro = error.response.data.message
            ? error.response.data.message
            : "";
          this.$toast.error(`Ocorreu um erro ao anexar arquivo. ${msgErro}`);
        });
      this.anexo.tipo = null;
    },

    removerAnexo(index) {
      const arquivoId = this.movimentoAnexos[index].anexo.arquivoId;
      removerAnexo(arquivoId).then(() => {
        this.movimentoAnexos.splice(index, 1);
      });
    },
    async listarMovimentoAnexos() {
      if (this.rascunho.id) {
        await listarMovimentoAnexos(this.rascunho.id).then(response => {
          this.movimentoAnexos = response;
        });
      }
    },
    async tiposAnexos() {
      await listarTiposAnexo().then(response => {
        this.dmTiposAnexos = response;
      });
    },
    setTipoRecebimentoBoleto(e, descricao) {
      let tipoRebimentoBol = descricao ? descricao : e.target.value;
      this.mostraTiposRecebimentoBoleto = null;
      if (
        tipoRebimentoBol.replace(/[^a-zA-Z ]/g, "").toLowerCase() == "email"
      ) {
        this.mostraTiposRecebimentoBoleto = true;
      }
      this.tiposRecebimentoBoleto.forEach(e => {
        if (e.descricao == tipoRebimentoBol) {
          this.tipoRecebimentoBoletoId = e.id;
        }
      });
    },
    async getParametroFinalidadesDefault() {
      const parametroFinalidadesDefault =
        PARAMETROS.HABILITAR_FINALIDADES_ENDERECO_DEFAULT;
      const response = await getParametro(parametroFinalidadesDefault);
      this.parametroEnderecoFinalidadesDefault = response === "true";
    },
    tiposRecebimentoBoletos() {
      this.$api
        .get(api.listarTiposRecebimentoBoletos)
        .then(response => {
          this.tiposRecebimentoBoleto = response.data;
          response.data.forEach(element => {
            if (
              !element.dataInativacao ||
              moment(element.dataInativacao).format(dateFormat) > currentDate
            ) {
              this.dmRecebimentoBoletos.push(element.descricao);
            }
          });
        })
        .catch(error => {
          var errorMessage = error.response?.data?.message.split("|");

          if (WEB_SERVICE.includes(errorMessage[0])) {
            this.setErrorToast(error?.response?.data?.message);
          } else {
            this.setToast(
              "Erro ao carregar os tipos de recebimento de boleto."
            );
          }
        });
    },
    async buscaCep(index, cep) {
      const cepTratado = cep.replace(/\.|-/g, "");

      const novoEndereco = await getCep(cepTratado).then(response => {
        const errorMessage = response.data?.message;

        if (errorMessage) {
          this.setErrorToast(errorMessage);
        } else {
          const firstCep = response[0];

          if (firstCep) {
            this.verificaEdicaoCamposEndereco(index, firstCep);

            return firstCep;
          } else {
            this.setToast("CEP não encontrado");

            return null;
          }
        }
      });

      this.listEnderecos.forEach((endereco, enderecoIndex) => {
        if (enderecoIndex === index && novoEndereco !== null) {
          (endereco.bairro = novoEndereco.bairro),
            (endereco.cep = novoEndereco.cep),
            (endereco.cidade = novoEndereco.cidade),
            (endereco.logradouro = novoEndereco.logradouro),
            (endereco.uf = novoEndereco.uf);
        } else if (enderecoIndex === index && novoEndereco === null) {
          (endereco.bairro = null),
            (endereco.cidade = null),
            (endereco.logradouro = null),
            (endereco.uf = null);
        }
      });
    }
  }
};
</script>
<style scoped>
.container.grid-list-xs .layout .flex {
  padding: 1px !important;
}

#lblInfoBoleto {
  color: red;
  position: relative;
  font-size: 10px;
  left: 284px;
  top: -43px;
}
</style>
